import PAGE_VIEW_TYPES from 'config/consts';
import UBT, { UBT_TYPE } from '@ctrip/ubt-web';

const UBTUtil = {
  setLoginName(loginName) {
    if (typeof window.__bfi === 'undefined') {
      window.__bfi = [];
    }
    window.__bfi.push(['_set', 'loginName', loginName]);
  },
  trackMetric(metric) {
    if (typeof window.__bfi === 'undefined') {
      window.__bfi = [];
    }
    window.__bfi.push(['_trackMetric', metric]);
  },
  trace(key, data) {
    if (typeof window.__bfi === 'undefined') {
      window.__bfi = [];
    }
    window.__bfi.push(['_trace', key, data]);
  },
  devTrace(key, data) {
    if (typeof window.__bfi === 'undefined') {
      window.__bfi = [];
    }
    window.__bfi.push(['_devTrace', key, data]);
    console.log(PAGE_VIEW_TYPES.softwareInstall);
  },
  tracePageId(pageid) {
    if (typeof window.__bfi === 'undefined') {
      window.__bfi = [];
    }
    window.__bfi.push([
      '_asynRefresh',
      {
        page_id: pageid,
        loginName: localStorage.getItem('USER'),
      },
    ]);
  },
};

export const trackMetric = (module, userId) => {
  const data = {
    name: 'idesk_module_clikc',
    value: 1,
    tag: {
      module,
      userId,
    },
  };
  UBTUtil.trackMetric(data);
};

export const tracePageid = (viewType) => {
  const pageid = PAGE_VIEW_TYPES[viewType];
  UBTUtil.tracePageId(pageid);
};

export const ubtRegister = (viewType) => {
  const pageId = PAGE_VIEW_TYPES[viewType];
  const pvId = UBT.register({
    pageId,
    appId: 900001,
    business: {
      loginName: localStorage.getItem('USER'),
    },
  });
  console.log(pvId);
  console.log(pageId);
  return pvId;
};

/**
 * @param {number} key
 * @param {string} page
 * @param {string} action
 * @param {string} name
 * @param {string} nameId
 * @param {string} tag
 * @param {string} pvId
 * @param {string} pvId
 */
export const ubtSendTrace = (key, page, action, name, nameId, tag, pvId, error = '') => {
  UBT.send(
    {
      type: UBT_TYPE.TRACE,
      key,
      data: {
        page,
        action,
        name,
        name_id: nameId,
        tag,
        error,
      },
    },
    pvId,
  );
};

export const ubtSendMetric = (pvId, url, messageId, timecost, successFlag, error = '') => {
  const name = successFlag ? 'o_idesk_httpsuc' : 'o_idesk_httpfail';
  const key = successFlag ? '245695' : '245696';
  UBT.send(
    {
      type: UBT_TYPE.METRIC,
      key,
      data: {
        tag: {
          requestUrl: url,
          url,
          RootMessageId: messageId,
          reason: error,
          name,
        },
        value: timecost,
      },
    },
    pvId,
  );
};

export default UBTUtil;
